import { render, staticRenderFns } from "./ElevatorStatistics.vue?vue&type=template&id=2b470881&scoped=true&"
import script from "./ElevatorStatistics.vue?vue&type=script&lang=js&"
export * from "./ElevatorStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b470881",
  null
  
)

export default component.exports